import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

  transform(value, objectKey?: string): any {
    const keysList = [];
    let jsonResult;
    if (typeof value === 'string') {
      jsonResult = JSON.parse(value.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\f/g, '\\f'));
    } else {
      jsonResult = value;
    }
    if (objectKey) {
      const val = jsonResult[objectKey];
      if (objectKey !== 'amount') {
        return val;
      } else {
        return formatNumber(val, 'en');
      }
    } else {
      // tslint:disable-next-line:forin
      for (const k in jsonResult) {
        keysList.push(k);
      }
      return keysList;
    }
  }

}
